// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const grimer_alola: PokeData = {
  "id": 10112,
  "name": "grimer-alola",
  "height": 7,
  "weight": 420,
  "base_experience": 65,
  "types": [
    PokeType.POISON,
    PokeType.DARK
  ],
  "api_moves": [
    "pound",
    "bite",
    "disable",
    "toxic",
    "screech",
    "harden",
    "minimize",
    "poison-gas",
    "acid-armor",
    "sludge-bomb",
    "crunch",
    "memento",
    "knock-off",
    "poison-fang",
    "fling",
    "gunk-shot",
    "acid-spray",
    "belch"
  ],
  "moves": [
    "bite",
    "poison-gas",
    "sludge-bomb",
    "crunch",
    "poison-fang",
    "toxic-spikes",
    "lash-out",
    "purify",
    "phantom-force",
    "poison-jab",
    "acid",
    "stun-spore",
    "dark-pulse"
  ],
  "evolution_chain": {
    "id": 38,
    "item": null,
    "species": [
      {
        "name": "grimer",
        "order": 96,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "muk",
        "order": 97,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 88,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 50,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
